export enum OnboradingEvents {
  OPEN_FOLDER_MODAL = "open-folder-modal",
  CLOSE_FOLDER_MODAL = "close-folder-modal",
  CHOOSE_NO_FOLDER = "choose-no-folder",
  OPEN_MEDIA_MODAL = "open-media-modal",
  CLOSE_MEDIA_MODAL = "close-media-modal",
  OPEN_DOWNLOAD_APP_MODAL = "open-download-app-modal",
  CLOSE_DOWNLOAD_APP_MODAL = "close-download-app-modal",
}
